import baseApi from "./base"
import { ApplyRequest, ApplyResponse } from "./types/apply"
import { BaseResponse } from "./types/common"
import { GetCaptcha1Response, GetCaptcha1Request } from "./types/captcha"
import { GetConfigResponse } from "./types/config"

const functionCode = "SPE0025" // 24 tmsf, 25 ytm
const errorCounter = "3"
const lockHours = "24"
const fixedGuid = "-ABCDEFABCDEF"

const api = baseApi.injectEndpoints({
  overrideExisting: false,
  endpoints: (builder) => ({
    getTokenByTckn1: builder.mutation<BaseResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body,
          functionCode: functionCode,
          NextTransactionUrl: "Facebook/SocialMediaPortalCreateSession/GetTokenByTckn1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),    
    getConfig: builder.mutation<GetConfigResponse, string>({
      query: (body) => ({
        url: "",
        method: "POST",
        body : {
          configKey: body,
          NextTransactionUrl: "Facebook/SMPUConfig/GetConfig1",
          TokenSessionId: "ABCDEFABCDEFABCDEFABCDEFABCDEFABCDEF",
        },
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    getCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          vkn: body.vkn,
          TokenSessionId: body.TokenSessionId,
          Language: body.Language,
          NextTransactionUrl: "Facebook/TMSF/GetCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    refreshCaptcha: builder.mutation<GetCaptcha1Response, GetCaptcha1Request>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          tckn: body.tckn,
          vkn: body.vkn,
          TokenSessionId: body.TokenSessionId,
          Language: body.Language,
          NextTransactionUrl: "Facebook/TMSF/RefreshCaptcha1",
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    }),
    apply: builder.mutation<ApplyResponse, ApplyRequest>({
      query: (body) => ({
        url: "",
        method: "POST",
        body: {
          accountOwnerType: body.accountOwnerType,
          tckn: body.tckn,
          vkn: body.vkn,
          captcha: body.captcha,
          reportYear: body.reportYear,
          NextTransactionUrl: "Facebook/TMSF/YTMStep1",
          TokenSessionId: body.TokenSessionId,
        }
      }),
      transformResponse: (response: string) => JSON.parse(response)
    })
  })
})

export const { useGetTokenByTckn1Mutation, useGetCaptchaMutation, useRefreshCaptchaMutation, useApplyMutation, useGetConfigMutation } = api

export default api
